<template>
    <PtDialog
        class="increase-chart-dialog "
        custom-class="center"
        :visible="true"
        :close-on-click-modal="false"
        :title="data.title"
        :showClose="true"
        width="780px"
        @close="close"
    >
        <el-tabs
            v-model="currentTab"
            class="increase-chart-tabs">
            <el-tab-pane
                v-for="(item) in tabsList"
                :key="item.type"
                :name="item.type"
                :label="item.label"
            />
        </el-tabs>
        <div class="increase-chart-content-wrapper">
            <div class="increase-chart-content-loading" v-if="isLoading">
                <PtIcon icon="SolidLoadingBars"/>
            </div>
            <IncreaseChartContent
                v-else
                :type="currentTab"
                :increaseChartData="increaseChartData"
                :timeRange="timeRange"
                :isChartLoading="isChartLoading"
                @changeYear="changeYear"
            />
        </div>
    </PtDialog>
</template>

<script>
import { Dialog as PtDialog, Icon as PtIcon } from 'patsnap-biz';
import { Tabs, TabPane } from 'element-ui';
import IncreaseChartContent from './IncreaseChartContent';
import { fetchDataByCountry } from '../../../../../../../../../components/apis/core_basic_api/data_coverage';
import { get } from 'lodash';

import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

export default {
    name: 'IncreaseChartDialog',
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {
            }
        }
    },
    components: {
        IncreaseChartContent,
        PtDialog,
        PtIcon,
        ElTabs: Tabs,
        ElTabPane: TabPane
    },
    data() {
        return {
            isLoading: false,
            isChartLoading: false,
            currentTab: 'biblio',
            tabsList: [
                { label: this.$t('dataCoverage.globalPatentDatabases.bibliography'), type: 'biblio', year: 1 },
                { label: this.$t('page.status["Full Text"]'), type: 'fulltext', year: 1 },
                { label: this.$t('page.status["PDF"]'), type: 'pdf', year: 1 },
            ],
            increaseChartData: {
                totalQuantityList: [],
                incrementList: [],
                updateFrequency: '',
                updateDate: ''
            }
        };
    },
    watch: {
        currentTab() {
            if (this.currentTab !== '') {
                this.init(true);
            }
        }
    },
    computed: {
        timeRange() {
            return get(this.tabsList.find(tab => tab.type === this.currentTab), 'year', '');
        }
    },
    methods: {
        changeYear(val) {
            let currentTabs = this.tabsList.find(tab => tab.type === this.currentTab);
            currentTabs.year = val;
            this.init();
        },
        async init(isInit = false) {
            try {
                if (isInit) {
                    this.isLoading = true;
                } else {
                    this.isChartLoading = true;
                }
                let res = await fetchDataByCountry({
                    country: this.data.code,
                    contentType: this.currentTab,
                    range: this.timeRange
                });
                const updateFrequency = get(res, 'update_frequency', '');
                const updateDate = get(res, 'last_update', '');
                const totalQuantityObj = get(res, 'total_data', {});
                const incrementObj = get(res, 'new_data', {});
                let totalQuantityList = [];
                let incrementList = [];
                for (let key in totalQuantityObj) {
                    const totalCount = get(totalQuantityObj, key, 0);
                    const incrementCount = get(incrementObj, key, 0);
                    totalQuantityList.push({ name: key, value: totalCount });
                    incrementList.push({ name: key, value: incrementCount });
                }
                this.increaseChartData = {
                    totalQuantityList,
                    incrementList,
                    updateFrequency,
                    updateDate
                };
            } finally {
                this.isLoading = false;
                this.isChartLoading = false;
            }
        },
        close() {
            this.$emit('close', false);
        },
    },
    created() {
        if (this.data.code !== 'AU') {
            this.tabsList.push({ label: this.$t('dataCoverage.globalPatentDatabases.legalStatus'), type: 'legal', year: 1 });
        }
        this.init(true);
    },
};
</script>

<style lang="scss">
.patsnap-biz-dialog {
    &.increase-chart-dialog {
        .center {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: 0 !important;
        }

        .el-dialog__header {
            padding: 22px 50px 18px 50px;
        }

        .el-dialog__body {
            padding: 0 50px 30px;
        }

        .increase-chart-tabs {
            .el-tabs__active-bar {
                background-color: #33B900;
            }

            .el-tabs__item {
                font-size: 14px;
                font-weight: 500;
                color: #061632;

                &.is-active {
                    color: #33B900;
                }

                &:hover {
                    color: #33B900;
                }
            }

            .el-tabs__nav-wrap {
                &::after {
                    background-color: #E5E7ED;
                }
            }
        }
    }

    .increase-chart-content-wrapper {
        min-height: 462px;
        width: 100%;
        position: relative;

        .increase-chart-content-loading {
            height: 462px;
            display: flex;
            align-items: center;
        }

        .patsnap-biz-icon {
            &[icon="SolidLoadingBars"] {
                fill: $fill-normal !important;
                font-size: 48px;
                display: block;
                margin: 0 auto;
            }
        }
    }
}

</style>
